export const SUPPORTED_LOCALES = [ "en", "de" ] as const;

export type TSupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: TSupportedLocale = "en";
const GERMAN_COUNTRY_CODE = "DE";
export const GERMAN_LOCALE: TSupportedLocale = "de";

export const isSupportedLocale = (locale: string): locale is TSupportedLocale => (
  (SUPPORTED_LOCALES as readonly string[]).includes(locale)
);

export const isGermanLocale = (locale: TSupportedLocale): boolean =>
  locale === GERMAN_LOCALE;

export const isGermanCountryCode = (countryCode: string | null | undefined): boolean =>
  countryCode === GERMAN_COUNTRY_CODE;

/** BCP 47 language tag per supported locale, used by Intl APIs. */
export const LOCALE_TO_BCP47: Record<TSupportedLocale, string> = {
  en: "en-GB",
  de: "de-DE",
};

/** Returns the BCP 47 tag for a supported locale. */
export const getBcp47 = (locale: TSupportedLocale): string => (
  LOCALE_TO_BCP47[locale]
);

/**
 * Narrows a locale string to a `TSupportedLocale`, falling back to the default locale
 * for unsupported values. Use this when a locale comes from an external source
 * (route param, cookie, header) and may not be in the supported set.
 */
export const resolveLocale = (locale: string): TSupportedLocale => {
  if (isSupportedLocale(locale)) {
    return locale;
  }
  return DEFAULT_LOCALE;
};
